import { render, staticRenderFns } from "./t-badge.vue?vue&type=template&id=ff98af0c"
import script from "./t-badge.vue?vue&type=script&setup=true&lang=ts"
export * from "./t-badge.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports